import { LocalizationMessages } from '@corefy/localization/interfaces/LocalizationMessages';
import { en } from '@/translations/en';
import { ru } from '@/translations/ru';
import { uk } from '@/translations/uk';

export const localizationMessages: LocalizationMessages<typeof en> = { en, ru, uk };
